export default "__VITE_ASSET__871fde5a__"